import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../services/loader.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { MaterialsModule } from '../../modules/material.module';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule,NgxSpinnerModule,MaterialsModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css'
})
export class LoaderComponent implements OnDestroy  {
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  subcription!:Subscription;
  constructor(private loaderservice:LoaderService,private spinner:NgxSpinnerService) {
    this.subcription= this.loaderservice.isLoading.subscribe((request)=>{
      request?this.spinner.show():this.spinner.hide();
    });
   }

  ngOnInit(): void {
  }
ngOnDestroy(): void {
  if(this.subcription){
    this.subcription.unsubscribe();
  }
}
}
